import React, {useState} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from '@headlessui/react'
import clsx from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {BrgIconClose} from '~/icons/brg-icon-close'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {getDomainConfig} from '~/domains'

const AffiliateDisclosureHeaderNewLayout = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const [isAffiliateDisclosureOpen, setIsAffiliateDisclosureOpen] = useState(false)

  const reportWidgetClick = useReportWidgetClick()
  const [ctaRef] = useReportWidgetSeen({
    widget_name: 'affiliate-disclosure-cta',
    widget_place: 'top',
  })
  const [contentRef] = useReportWidgetSeen({
    widget_name: 'affiliate-disclosure-content',
    widget_place: 'top',
  })

  return (
    <>
      <div className="flex flex-row items-center gap-2 mobile:mt-0" ref={ctaRef} data-testid="affiliate-disclosure">
        <button
          type="button"
          onClick={() => {
            reportWidgetClick({
              widget_name: 'affiliate-disclosure-cta',
              widget_place: 'top',
              trigger_type: 'click',
            })
            setIsAffiliateDisclosureOpen(!isAffiliateDisclosureOpen)
          }}
          aria-label="open affiliate disclousure"
          className={clsx(
            'flex self-start rounded-lg px-3 py-1 text-sm font-light text-[#4F4F4F] shadow-elegant',
            stylesBydomain.LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON,
            'listpage_widgets_affiliatedisclosure_button',
          )}
        >
          {translations.affiliateDisclosure.title}
        </button>
      </div>
      <Dialog
        open={isAffiliateDisclosureOpen}
        as="div"
        className="relative z-50 focus:outline-none"
        onClose={() => {
          reportWidgetClick({
            widget_name: 'affiliate-disclosure-close',
            widget_place: 'dialog',
            trigger_type: 'click',
          })
          setIsAffiliateDisclosureOpen(false)
        }}
      >
        <DialogBackdrop className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4" ref={contentRef}>
          <DialogPanel
            transition
            className="data-[closed]:transform-[scale(95%)] relative w-full max-w-md rounded-lg bg-white p-6 duration-300 ease-out data-[closed]:opacity-0"
          >
            <button
              type="button"
              aria-label="close affiliate disclousure"
              className="absolute right-4 top-6"
              onClick={() => {
                reportWidgetClick({
                  widget_name: 'affiliate-disclosure-close',
                  widget_place: 'dialog',
                  trigger_type: 'click',
                })
                setIsAffiliateDisclosureOpen(false)
              }}
            >
              <BrgIconClose fill="black" className="size-4" />
            </button>
            <DialogTitle as="h3" className="text-base font-medium leading-[17px] text-neutral-800">
              {translations.affiliateDisclosure.title}
            </DialogTitle>
            <div className="mt-3 border-t border-neutral-200" />
            <p className="mt-3 text-[14px] font-light leading-[17px] text-neutral-800">
              {translations.affiliateDisclosure.content}
            </p>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  )
}

export default AffiliateDisclosureHeaderNewLayout
